var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"outer-wrap"},[_c('div',{staticClass:"main-content",attrs:{"id":"inner-wrap"}},[_c('div',{staticClass:"main-portal-wrap"},[_c('div',{staticClass:"main-portal-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-8"},[_c('div',{staticClass:"wpart part-user-profile"},[_vm._t("default")],2)])])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }